import * as React from 'react';
import { Link } from 'react-router-dom';
import Page from '../components/Page';
import ContractList from '../components/ContractList';
import Loader from '../components/Loader';
import { ErrorFlash } from '../components/Flash';
import { classes } from '../components/Button';
import { ProfileContext, ProfileManager } from '../profile';
import { useRequest, getHeaders } from '../api/client';
import { Contract } from '../contract';

const newContract: Contract = {
  id: null,
  company_id: null,
  company_name: '',
  type: 'sale_fee',
  trial_days: 0,
  product_limit: 0,
  percentage: 0,
  amount: 0,
  amount_currency: 'GBP',
  notes: '',
  is_active: true,
  is_in_trial: false,
  billing_info: {
    account_holder: '',
    account_number: '',
    address_city: '',
    address_country: '',
    address_county: '',
    address_line_1: '',
    address_line_2: '',
    address_postal_code: '',
    bank_address: '',
    bank_name: '',
    routing_number: '',
    swift_number: '',
  },
  started_at: null,
  created_at: null,
  updated_at: null,
};

const contracts = (context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: '/store/contracts',
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

export default function Contracts() {
  const context = React.useContext(ProfileContext);
  const state = contracts(context);

  if (state.loading) {
    return <Loader />;
  }

  return (
    <Page title="Contracts" subtitle="Manage the contracts">
      {state.error && <ErrorFlash error={state.error} />}
      <div className="flex justify-center ml-auto mr-auto">
        <Link
          to={{
            pathname: '/contracts/edit/new',
            state: {
              contract: { ...newContract },
            },
          }}
          className={`${classes} dib ml-auto mr-auto`}
        >
          Create new
        </Link>
      </div>
      <ContractList contracts={state.data || []} />
    </Page>
  );
}
